export default __webpack_public_path__ + "069d202a8b42fddf211a5e0a4bbea800.svg";